import { UserCog } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { impersonationWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  impersonationWeb,
  {
    ImpersonationBanner: () => import('./ImpersonationBanner'),
    StartImpersonationDialog: () => import('./StartImpersonationDialog'),
    AdminUserImpersonateAction: () => import('./AdminUserImpersonateAction'),
  },
  {
    icons: { UserCog },
  },
);
